import { render, staticRenderFns } from "./LoginRegisterModal.vue?vue&type=template&id=1efc3663&"
import script from "./LoginRegisterModal.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports